// removed by extract-text-webpack-plugin
module.exports = {"Select":"Select__Select___1cDpZ","Open":"Select__Open___3fR_J","Dropdown":"Select__Dropdown___2WIoc","Input":"Select__Input___2eAM8","Backdrop":"Select__Backdrop___2Oqy7","InputError":"Select__InputError___NJpyZ","List":"Select__List___3HdeT","Item":"Select__Item___3-OuS","selected":"Select__selected___3mv24","ChevronDown":"Select__ChevronDown___PPABm","ChevronUp":"Select__ChevronUp___yMf6s"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Login/FormRegistration/Select.scss
// module id = 1363
// module chunks = 0